<template>
	<gc-dialog
		width="860px"
		:show.sync="visible"
		title="选择采集器"
		ok-text="确 定"
		:show-close="false"
		@ok="handleConfirm"
		@cancel="handleClose"
		@close="handleClose"
	>
		<div class="collector-dialog">
			<gc-table
				ref="collectorTable"
				v-loading="loading"
				border
				:columns="collectorColumns"
				:table-data="collectors"
				:total-hide="false"
				:is-highlight-current="true"
				:row-class-name="getRowClassName"
				@row-click="handleRowClick"
			></gc-table>
		</div>
	</gc-dialog>
</template>

<script>
export default {
	name: 'CollectorSelectDialog',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		collectors: {
			type: Array,
			default: () => [],
		},
		selectedId: {
			type: [String, Number],
			default: '',
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			currentRow: null,
			collectorColumns: [
				{ name: '采集器名称', key: 'name', minWidth: 150, tooltip: true },
				{ name: '编号', key: 'code', minWidth: 130, tooltip: true },
				{ name: '安装位置', key: 'installLocation', minWidth: 180, tooltip: true },
				{
					name: '通道数量',
					key: 'channelCount',
					width: 100,
					render: (h, row) => h('span', `${row.channelCount}通道`),
				},
				{
					name: '已用通道数量',
					key: 'usedChannelCount',
					width: 120,
					render: (h, row) => h('span', `${row.usedChannelCount}个`),
				},
			],
		}
	},
	computed: {
		visible: {
			get() {
				return this.show
			},
			set(val) {
				this.$emit('update:show', val)
			},
		},
	},
	watch: {
		show(val) {
			if (val) {
				this.setCurrentRow()
			}
		},
		collectors() {
			if (this.show) {
				this.setCurrentRow()
			}
		},
	},
	methods: {
		setCurrentRow() {
			this.currentRow = this.collectors.find(item => item.id === this.selectedId) || null
			this.$nextTick(() => {
				this.$refs.collectorTable?.setCurrentRow(this.currentRow)
			})
		},
		getRowClassName({ row }) {
			return this.currentRow && row.id === this.currentRow.id ? 'is-selected-row' : ''
		},
		handleRowClick({ row }) {
			this.currentRow = row
		},
		handleConfirm() {
			if (!this.currentRow) {
				this.$message.warning('请选择采集器')
				return
			}
			this.$emit('select', this.currentRow)
			this.visible = false
		},
		handleClose() {
			this.visible = false
		},
	},
}
</script>

<style lang="scss" scoped>
.collector-dialog {
	padding: 4px 0 12px;
}

::v-deep .el-table {
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	overflow: hidden;

	th {
		background: #f8fafc;
		color: #334155;
		font-weight: 600;
	}

	.el-table__row {
		cursor: pointer;
	}

	.is-selected-row td {
		background: #eff6ff;
	}
}
</style>
